import React, { useMemo } from "react";

import { ErrorMessage, PrimaryButton, SecondaryButton, Text } from "widgets";
import Loader from "Shared/Loader/Loader";

import styles from "./ConfirmOrder.module.scss";
import { debounce } from "lodash";

const DEBOUNCE_TIME_IN_MS = 15000;

const ConfirmOrder = (props) => {
  const { onConfirm,onCancel, isPending, error, isError } = props;

  const debouncedConfirm = useMemo(
    () =>
      debounce(onConfirm, DEBOUNCE_TIME_IN_MS, {
        leading: true,
        trailing: false,
      }),
    [onConfirm]
  );

  return (
    <div className={styles.popOverContainer}>
      <Text>Are you sure you want to confirm order?</Text>
      <div className={styles.flexContainer}>
        <SecondaryButton onClick={onCancel}>Go Back</SecondaryButton>
        <PrimaryButton onClick={debouncedConfirm} disabled={isPending}>
          {isPending ? <Loader /> : "Confirm and Proceed"}
        </PrimaryButton>
      </div>
      {isError && <ErrorMessage>{error.message}</ErrorMessage>}
    </div>
  );
};
export default ConfirmOrder;
